export default __webpack_public_path__ + "static/media/icon_chevron-right.93f50220.svg";